import { toast } from "react-toastify";
import { getRateCard, getSubCity } from "redux/actions/UserRateCard";
import store from "redux/store";
import { call, put, takeEvery } from "redux-saga/effects";
import { postRateCardApi, rateCardApi, getTripPriceApi, getCompanyDutyType, getCompanyLocation,getSubCityNames } from "services/RateCardService";
import { GET_ADDRATECARD, GET_RATECARD, GET_TRIPPRICE, GET_COMPANYDUTY, GET_COMPANYLOCATION, GET_SUBCITY } from "resources/actionTypes";
import { onLoaderTrigger } from "redux/actions/commonAction";
import { getCar } from "redux/actions/UserCar";

function* fetchRateCard(action) {
  try {
    const payload = action.payload || {}
    const userRateCard = yield call(rateCardApi, payload);
    yield put({ type: GET_RATECARD.GET_RATECARD_SUCCESS, userRateCard: userRateCard });
  } catch (e) {
    yield put({ type: GET_RATECARD.GET_RATECARD_FAILED, message: e.message })
  }
}

export function* rateCardSaga() {
  yield takeEvery(GET_RATECARD.GET_RATECARD_REQUESTED, fetchRateCard);
}

function* fetchAddRateCard(action){
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {}
  const userAddRateCard = yield call(postRateCardApi,payload.userAddRateCard);
  if(userAddRateCard.success){
    yield put({ type: GET_ADDRATECARD.GET_ADDRATECARD_SUCCESS, userAddRateCard: userAddRateCard});
    toast.success(userAddRateCard.message);
    store.dispatch(getRateCard({
      carType: payload?.userAddRateCard?.carType,
      type: payload?.userAddRateCard?.type,
      baseFuelPrice:parseFloat(payload?.userAddRateCard?.baseFuelPrice),
      location:payload?.userAddRateCard?.location,
      contractId:payload?.userAddRateCard?.contractId,
      subCity:payload?.userAddRateCard?.subLocation,
    }));
  }
  else{
    yield put({ type: GET_ADDRATECARD.GET_ADDRATECARD_FAILED, message: userAddRateCard.message})
      toast.error(userAddRateCard?.message ||'Add Rate Card Failed');
  }
  store.dispatch(onLoaderTrigger(false));
}
export function* addRateCardSaga(){
  yield takeEvery(GET_ADDRATECARD.GET_ADDRATECARD_REQUESTED, fetchAddRateCard);
}

function* fetchGetTripPrice(action){
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {}
  const getTripRate = yield call(getTripPriceApi,payload.userGetTrip);
  if(getTripRate.success){
    yield put({ type: GET_TRIPPRICE.GET_TRIPPRICE_SUCCESS, getTripRate: getTripRate});
    toast.success(getTripRate?.message);
    store.dispatch(onLoaderTrigger(false));
  }
  else{
    yield put({ type: GET_TRIPPRICE.GET_TRIPPRICE_FAILED, message: getTripRate.message})
      toast.error(getTripRate?.message || 'Get Trip Price Failed');
      store.dispatch(onLoaderTrigger(false));
  }
}
export function* getTripPriceSaga(){
  yield takeEvery(GET_TRIPPRICE.GET_TRIPPRICE_REQUESTED, fetchGetTripPrice);
}

function* fetchCompanyLocation(action) {
  try {
    const payload = action.payload || {}
    const userCompanyLocation = yield call(getCompanyLocation, payload);
    yield put({ type: GET_COMPANYLOCATION.GET_COMPANYLOCATION_SUCCESS, userCompanyLocation: userCompanyLocation });
  } catch (e) {
    yield put({ type: GET_COMPANYLOCATION.GET_COMPANYLOCATION_FAILED, message: e.message })
  }
}

export function* companyLocationSaga() {
  yield takeEvery(GET_COMPANYLOCATION.GET_COMPANYLOCATION_REQUESTED, fetchCompanyLocation);
}

function* fetchCompanyDuty(action) {

  const payload = action.payload || {}
    const userCompanyDuty = yield call(getCompanyDutyType, payload?.data);

    if (userCompanyDuty?.success) {
      yield put({ type: GET_COMPANYDUTY.GET_COMPANYDUTY_SUCCESS, userCompanyDuty: userCompanyDuty });

      if(payload?.type) {
        const payloadData = {
         ...payload?.data,
         type: userCompanyDuty?.data?.[0]?.tripType,
        }

        const dutyType = userCompanyDuty?.data?.map((val) => ({
          id: val.tripType,
          name: val.name,
        }));

        payload?.setSubCityStatus(dutyType?.[0]?.id === 4 ? 0 : 3);

        const filterValues = {
          ...payload?.filterValues,
          dutyType: dutyType?.[0]
        }

        payload?.setFilterValues(filterValues);

        if(userCompanyDuty?.data?.[0]?.tripType === 4) {
          store.dispatch(getSubCity(payload?.filterValues?.cityType?.id, "ratecard", payload?.setFilterValues, filterValues));
        }
        store.dispatch(getCar(payloadData, "ratecard", payload?.setFilterValues, filterValues))
      }
    }
    else {
      yield put({ type: GET_COMPANYDUTY.GET_COMPANYDUTY_FAILED, message: userCompanyDuty?.message })
    }
}

export function* companyDutySaga() {
  yield takeEvery(GET_COMPANYDUTY.GET_COMPANYDUTY_REQUESTED, fetchCompanyDuty);
}


function* fetchSubCity(action) {

  try {
    const payload = action.payload || {}

    const userSubCity = yield call(getSubCityNames, payload?.id);
    yield put({ type: GET_SUBCITY.GET_SUBCITY_SUCCESS, userSubCity: userSubCity });

    if(payload?.type) {

      const subCity = userSubCity?.data?.map((val) => ({
        id: val.id,
        name: val.name,
      }));

      const filterValues = {
        ...payload?.filterValues,
        subCityType: {id: "", name: ""}
      }

      payload?.setFilterValues(filterValues);
    }

  } catch (e) {
    yield put({ type: GET_SUBCITY.GET_SUBCITY_FAILED, message: e.message })
  }
}

export function* fetchSubCitySaga() {
  yield takeEvery(GET_SUBCITY.GET_SUBCITY_REQUESTED, fetchSubCity);
}
